import MungPayUtil from '../../core/utils/LogUtil';
import { ApiClient } from '../../core/api/ApiClient';
import { MungPayRepositoryImpl } from './implementations';
import { MungPayService } from './services';

// MungPay Domain Exports
export * from './interfaces';
export * from './services';
export * from './implementations';

/**
 * MungPay Domain Dependency Injection Container
 * 의존성 주입을 통한 클린 아키텍처 구현
 */
class MungPayDomainContainer {
  constructor() {
    this._apiClient = null;
    this._mungPayRepository = null;
    this._mungPayService = null;
  }

  /**
   * ApiClient 인스턴스 (Singleton)
   */
  get apiClient() {
    if (!this._apiClient) {
      const baseUrl =
        import.meta.env.VITE_API_V2_BASE_URL || 'https://api2.pevo.care';
      this._apiClient = new ApiClient(`${baseUrl}`);
      MungPayUtil.log(
        '🔧 [MungPay Domain] ApiClient 인스턴스 생성:',
        `${baseUrl}`
      );
    }
    return this._apiClient;
  }

  /**
   * MungPayRepository 인스턴스 (Singleton)
   */
  get mungPayRepository() {
    if (!this._mungPayRepository) {
      this._mungPayRepository = new MungPayRepositoryImpl(this.apiClient);
      MungPayUtil.log('🔧 [MungPay Domain] MungPayRepository 인스턴스 생성');
    }
    return this._mungPayRepository;
  }

  /**
   * MungPayService 인스턴스 (Singleton)
   */
  get mungPayService() {
    if (!this._mungPayService) {
      this._mungPayService = new MungPayService(this.mungPayRepository);
      MungPayUtil.log('🔧 [MungPay Domain] MungPayService 인스턴스 생성');
    }
    return this._mungPayService;
  }

  /**
   * 컨테이너 상태 초기화 (테스트용)
   */
  reset() {
    this._apiClient = null;
    this._mungPayRepository = null;
    this._mungPayService = null;
    MungPayUtil.log('🔄 [MungPay Domain] 컨테이너 초기화 완료');
  }
}

// Singleton 인스턴스
const container = new MungPayDomainContainer();

/**
 * MungPay Service 인스턴스 획득
 * @returns {MungPayService}
 */
export const getMungPayService = () => {
  MungPayUtil.log('📦 [MungPay Domain] MungPayService 인스턴스 요청');
  return container.mungPayService;
};

/**
 * 개발/테스트용 컨테이너 리셋
 */
export const resetMungPayContainer = () => {
  container.reset();
};
export const mungPayService = getMungPayService();

// 개발 환경에서 글로벌 디버깅 지원
if (import.meta.env.DEV) {
  window.__MUNGPAY_CONTAINER__ = container;
  MungPayUtil.log(
    '🚧 [MungPay Domain] 개발 모드 - 글로벌 컨테이너 디버깅 활성화'
  );
}
